export default __webpack_public_path__ + "static/media/Points_being_collected.4f7459ab.gif";